
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-verification/success",
      function () {
        return require("private-next-pages/email-verification/success.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-verification/success"])
      });
    }
  